import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EasyDrawer, FormPage, ListTableContext } from 'src/components'
import { $consts } from 'src/plugins'
import { getSingleRule } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const CustomModalBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  const formData = useMemo(() => {
    const { __RECORD__: record, CUSTOM_PARAMS } = props.config
    if (!CUSTOM_PARAMS) return { formId: record.ID }

    return {
      formId: record.ID,
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_LIST_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_ROW'],
        data: {
          [CUSTOM_PARAMS]: record.ID
        }
      },
      filterGroup: { Rules: [getSingleRule(CUSTOM_PARAMS, 1, record.ID)] },
    }
  }, [props.config.__RECORD__, props.config.CUSTOM_PARAMS])

  const slot = useMemo(() => {
    const { __RENDER_SLOT__: renderSlot, LABEL, ICON } = props.config
    return renderSlot?.(props.config) ?? (
      <span>
        <EasyIcon type={ICON} defaultIcon='FormOutlined' className='fz-16' />
        <span title={LABEL} className='pd-l4'>{LABEL}</span>
      </span>
    )
  }, [props.config])

  if (table?.dynamicJs[props.config.CLICK_EVENT] instanceof Function) {
    return table.dynamicJs[props.config.CLICK_EVENT](table, props)
  }

  const { FORM_CODE, DRAWER_MODAL, WIDTH } = props.config
  if (DRAWER_MODAL) {
    return (
      <EasyDrawer drawer={{ title: FORM_CODE }} slot={slot}>
        <FormPage formCode={FORM_CODE} formData={formData} />
      </EasyDrawer>
    )
  }
  return (
    <EasyModal modal={{ title: FORM_CODE, width: WIDTH }} slot={slot}>
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default CustomModalBtn